import { formatRubKopecks } from '@/lib/money';

/** KAN-744: конверсия менеджера в интерфейсе: 12.345 -> "12.3%". */
export function formatConversion(value: number | null | undefined): string {
  const n = Number(value) || 0;
  return `${Math.round(n * 10) / 10}%`;
}

/** KAN-745: процент с продаж: 5 -> "5 %", 2.5 -> "2,5 %", null -> "-". */
export function formatCommission(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return `${Number(value).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} %`;
}

/** KAN-745: сумма к выплате с копейками; null (процент не задан) -> "-". */
export function formatPayout(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return formatRubKopecks(value);
}

export const COMMISSION_ERROR = 'Процент с продаж: число от 0 до 100, не больше двух знаков после запятой';

/**
 * KAN-745: процент из поля ввода. Пусто: null (не задан). Запятая как точка.
 * Не число, вне 0..100 или больше двух знаков после запятой: undefined (ошибка).
 */
export function parseCommission(raw: string): number | null | undefined {
  const text = (raw ?? '').replace(/\s/g, '').replace(',', '.');
  if (!text) return null;
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return undefined;
  const n = Number(text);
  return n >= 0 && n <= 100 ? n : undefined;
}
